export const iconFontAwesomeDesignStapler = (
	<i className="fa-solid fa-stapler"></i>
);
